export default "__VITE_ASSET__DabJSSVw__"